/*
*###############################################################################
*Module Name                   : SalesExecutiveMaster.js                       #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : W M Minol Prageesha                           #
*Date                          : Tuesday, August 24th 2021, 4:21:36 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/ //Table: M_TBLSALESASSISTANTS


import React, { useState, useEffect, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    TabContent,
    TabPane,
} from "reactstrap"


//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import SalesExecutiveMasterTab1 from "./salesExecutiveMasterGenaral"
import SalesExecutiveMasterTab2 from "./salesExecutiveMasterContact"
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPInfoBox from "framework/layout/DPInfoBox"
import NoiMage from "assets/images/product/noimage.jpg"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx";
import DPPrintOption from "framework/widgets/DPPrintOptions"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { DeleteSalesExecutiveMasterDetails, SalesExecutiveMasterDetailsGetData } from "./SalesExecutiveMasterController"

const photovalues = {
    imageSrc: NoiMage,
    imageFile: null,
}


const SalesExecutiveMaster = props => {

    let history = useHistory();
    // Tab 1 use state
    const [strCode, SetCode] = useState("");
    const [strTitle, Settitle] = useState("");
    const [strFName, Setfname] = useState("");
    const [strLname, Setlname] = useState("");
    const [strFullName, Setfulname] = useState("");
    const [strGroup, Setgcode] = useState();
    const [strLinkRefe, Setrefcode] = useState("");
    const [strNIC, Setidnum] = useState("");
    const [strGLCode, SetGlRef] = useState("");
    const [IsActive, SetActive] = useState(true);
    const [strLoca, Setreglocation] = useState("");
    const [strGender, Setgender] = useState("");
    const [strDesignation, Setjobdesig] = useState("");
    const [ErrorMsg, setErrorMsg] = useState('');
    const [addNew, setaddNew] = useState(true)
    const [menuCode, SetMenuCode] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    const [joinDate, setJoinDate] = useState("")
    const [resignDate, setResignDate] = useState("")




    // Tab 2 use state
    const [strAddress1, Setaddress1] = useState("");
    const [strAddress2, Setaddress2] = useState("");
    const [strAddress3, Setaddress3] = useState("");
    const [strAddress4, Setaddress4] = useState("");
    const [strArea, Setarea] = useState("");
    const [strMobile1, Setmobi1] = useState("");
    const [strMobile2, Setmobi2] = useState("");
    const [strTelephone1, Settele1] = useState("");
    const [strTelephone2, Settele2] = useState("");
    const [strFax, Setfax] = useState("");
    const [strEmail, Setemail] = useState("");

    // set desable or editable


    const [modal_xlarge, setmodal_xlarge] = useState(false);
    const [show, setShow] = useState(false);
    const [AlertMsg, setAlertMsg] = useState('');
    const [AlertColor, setAlertColor] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [DisabledCode, setDisabledCode] = useState(false);
    const [saveBtnEnable, setSaveEnable] = useState(true);
    const [crEnable, setCrEnable] = useState(false);
    const [crBy, setCrBy] = useState("");
    const [mdBy, setMdBy] = useState("");
    const [crDate, setCrDate] = useState("");
    const [mdDate, setMdDate] = useState("");
    const [picture, setPicture] = useState(photovalues);
    const [ImgName, setImgName] = useState("");
    const [Imgvalue, setImgvalue] = useState("");

    const [Genderstate, setGenderstate] = useState(false);

    const [DataTables, SetDatatable] = useState([])

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [customActiveTab, setcustomActiveTab] = useState("1")
    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)
    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    //const authToken = localStorage.getItem("authToken")
    const [helpUrl, setHelpUrl] = useState("")
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite, emailRegexp, mobileNumberRegexp
    } = useContext(Context);
    //import from contexts

    var time = process.env.REACT_APP_ALERTTIMEOUT

    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)
        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }


    }, [strCode])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])


    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };


    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
        }
    }


    //*** Get and Set values when user search code */
    async function setCodeFind(CodeFind) {

        if (CodeFind == "") return

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await SalesExecutiveMasterDetailsGetData(CodeFind);

        SetLoadingAlert(false)

        if (result.success == true) {

            SetCode(result.data.code)
            Settitle(result.data.title)
            Setfname(result.data.fName)
            Setlname(result.data.lname == "zz" ? "" : result.data.lname)
            Setfulname(result.data.fullName == "z" ? "" : result.data.fullName)
            Setgcode(result.data.group)
            Setrefcode(result.data.linkRefe == "_" ? "" : result.data.linkRefe)
            Setidnum(result.data.nic)
            setGenderstate(result.data.nic == "" ? false : true)
            SetGlRef(result.data.glCode == "_" ? "" : result.data.glCode)
            SetActive(result.data.status)
            Setreglocation(result.data.loca)
            Setgender(result.data.gender)
            Setjobdesig(result.data.designation == "_" ? "" : result.data.designation)
            Setaddress1(result.data.address1)
            Setaddress2(result.data.address2 == "_" ? "" : result.data.address2)
            Setaddress3(result.data.address3 == "_" ? "" : result.data.address3)
            Setaddress4(result.data.address4 == "_" ? "" : result.data.address4)
            Setarea(result.data.area)
            Setmobi1(result.data.mobile1)
            Setmobi2(result.data.mobile2 == "1" ? "" : result.data.mobile2)
            Settele1(result.data.telephone1 == "1" ? "" : result.data.telephone1)
            Settele2(result.data.telephone2 == "1" ? "" : result.data.telephone2)
            Setfax(result.data.fax == "1" ? "" : result.data.fax)
            Setemail(result.data.email == "_" ? "" : result.data.email)
            setCrBy(result.data.createdBy)
            setMdBy(result.data.modifiedBy)
            setCrDate(result.data.createdDate)
            setMdDate(result.data.modifiedDate)

            setPicture(result.data.strImageUrl == "images/SalesAssistant/zz" ? photovalues : { imageSrc: `${window.Links.MediaServer + localStorage.getItem("Serial") + "/"}${result.data.strImageUrl}` })
            setImgName(result.data.strImageUrl == "zz" ? "" : result.data.strImageUrl)
            setImgvalue("")
            setJoinDate(result.data.strJoinDate.slice(0, 10) == "1900-01-01" ? "" : result.data.strJoinDate.slice(0, 10))
            setResignDate(result.data.strResignDate.slice(0, 10) == "1900-01-01" ? "" : result.data.strResignDate.slice(0, 10))


            setDisabled(true)
            setDisabledCode(true)
            setSaveEnable(false)
            setCrEnable(true)
            SetDeleteEnable(true)
            setSearchdisabled(true)
            setReason("Updated")
            SetEditEnable(true)
            setaddNew(false)

        } else {
            if (nullCode == false) {
                displayAlertMessage('success', "Record Not Found !")
                setDisabledCode(true)
                SetCode("")
            }
        }
    }
    //*** End useEffect */

    //**Recall and set values to relevant contrls based on the selected record from the search window  */
    const executive_SelectRowSearch = (e, row, isSelect, rowIndex) => {
        setCodeFind(row.SA_CODE);

        setmodal_xlarge(!modal_xlarge)
    }


    const tabList = [
        {
            text: "General Information",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            }
        },
        {
            text: "Contact Details",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            }
        },
        // {
        //     text: "Performance Details",
        //     icon: "far fa-user",
        //     tabID: "3",
        //     onClick: () => {
        //         toggleCustom("3")
        //     }
        // },

    ];


    const getSalesAssistant = async () => {
        var data = [];
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        };
        await fetch(`${ApiURL}salesassistant/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                data = result.data;
            })
            .catch(error => console.log('error', error));
        return data;
    }


    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }
    //Clear

    const ClearItem = () => {
        SetCode("")
        Settitle("")
        Setfname("")
        Setlname("")
        Setfulname("")
        Setgcode("")
        Setrefcode("")
        Setidnum("")
        SetGlRef("")
        SetActive(true)
        Setreglocation("")
        Setgender("")
        Setjobdesig("")
        setImgName("")
        Setaddress1("")
        Setaddress2("")
        Setaddress3("")
        Setaddress4("")
        Setarea("")
        Setmobi1("")
        Setmobi2("")
        Settele1("")
        Settele2("")
        Setemail("")
        Setfax("")
        setImgvalue("")
        setErrorMsg("")
        setGenderstate(false)
        setPicture(photovalues)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        setSaveEnable(true)
        SetEditEnable(false)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        setaddNew(true)
        setcustomActiveTab("1")
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }

    //Toolbar Fucntions
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setaddNew(true)
    }

    const handlesave = async () => {

        var ExcelItemsRows = [...Excelitems]
        if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {

            var rowcount = ExcelItemsRows.length
            var errorcount = 0

            var mapexport = ExcelItemsRows.map(
                async (localState) => {
                    if ((localState.Code != "") && (localState.Description != "") && ((localState.Active != "") || !localState.Active) && (localState.strFName != "") && (localState.strGroup != "") && (localState.NIC != "") && (localState.strAddress1 != "") && (localState.strArea != "") && (localState.strMobile1 != "")) {
                        var formdata1 = new FormData();

                        var code = localState.Code
                        var description = localState.Description
                        var fname = localState.strFName == null ? "zz" : localState.strFName
                        var lname = localState.strLName == null ? "z" : localState.strLName
                        var fulname = localState.strFullName == null ? "" : localState.strFullName
                        var gcode = localState.strGroup
                        var refcode = localState.strLinkRefe == null ? "_" : localState.strLinkRefe
                        var nic = localState.strNIC
                        var glcode = localState.strGLCode == null ? "_" : localState.strGLCode
                        var loca = localState.strLoca
                        var gender = localState.strGender == null ? "1" : localState.strGender
                        var designation = localState.strDesignation == null ? "_" : localState.strDesignation
                        var addres1 = localState.strAddress1 == null ? "_" : localState.strAddress1
                        var addres2 = localState.strAddress2 == null ? "_" : localState.strAddress2
                        var addres3 = localState.strAddress3 == null ? "_" : localState.strAddress3
                        var addres4 = localState.strAddress4 == null ? "_" : localState.strAddress4
                        var area = localState.strArea
                        var mobi1 = localState.strMobile1 == null ? "1" : localState.strMobile1
                        var mobi2 = localState.strMobile2 == null ? "1" : localState.strMobile2
                        var tele1 = localState.strTelephone1 == null ? "1" : localState.strTelephone1
                        var tele2 = localState.strTelephone2 == null ? "1" : localState.strTelephone2
                        var fax = localState.strFax == null ? "1" : localState.strFax
                        var email = localState.strEmail == null ? "_" : localState.strEmail
                        var active = localState.Active


                        formdata1.append("strCode", code);
                        formdata1.append("strTitle", description);
                        formdata1.append("strFName", fname);
                        formdata1.append("strLname", lname);
                        formdata1.append("strFullName", fulname);
                        formdata1.append("strGroup", gcode);
                        formdata1.append("strLinkRefe", refcode);
                        formdata1.append("strNIC", nic);
                        formdata1.append("strGLCode", glcode);
                        formdata1.append("strLoca", loca);
                        formdata1.append("strGender", gender);
                        formdata1.append("strDesignation", designation);
                        formdata1.append("strAddress1", addres1);
                        formdata1.append("strAddress2", addres2);
                        formdata1.append("strAddress3", addres3);
                        formdata1.append("strAddress4", addres4);
                        formdata1.append("strArea", area);
                        formdata1.append("strMobile1", mobi1);
                        formdata1.append("strMobile2", mobi2);
                        formdata1.append("strTelephone1", tele1);
                        formdata1.append("strTelephone2", tele2);
                        formdata1.append("strFax", fax);
                        formdata1.append("strEmail", email);
                        formdata1.append("IsActive", active);
                        formdata1.append("strMenuCode", menuCode);
                        formdata1.append("strLoggedLocation", LocationCode);
                        formdata1.append("strLoggedCompany", LogCompanyCode);
                        formdata1.append("strReason", Reason);
                        formdata1.append("strCreateBy", LogUserType);
                        formdata1.append("blAddNew", addNew);
                        formdata1.append("strImagePath", "zz");
                        formdata1.append("strSerial", !localStorage.getItem("Serial") ? "" : localStorage.getItem("Serial"))


                        // formdata1.forEach((value, key) => {
                        //     console.log(key + " " + value)
                        // });

                        await fetch(`${ApiURL}salesassistant/`,
                            {
                                method: 'POST',
                                body: formdata1,
                                redirect: 'follow',
                                headers: { 'Authorization': `Bearer ${authToken}` },
                            }
                        ).then(async (Response) => {
                            if (Response.status == "200") {
                                await Response.json()
                                    .then(responseData => {
                                        if (responseData.data == "Record Already Exsist!") {
                                            errorcount++
                                        } else if (responseData.data == "Code Already Exsist!") {
                                            errorcount++
                                        }
                                    }
                                    )
                            } else if (Response.status == "400") {
                                errorcount++
                            } else {
                                errorcount++
                            }
                        })
                    } else {
                        errorcount++
                    }
                }
            )

            await Promise.all(mapexport)
            if (errorcount > 0) {
                setAlertColor("danger")
            } else {
                setAlertColor("success")
            }
            setAlertMsg(`From ${rowcount} Records ${rowcount - errorcount} Records saved successfully and ${errorcount} Records failed to save.`)
            setShow(true)
            setTimeout(() => {
                setShow(false)
                handleNew();
            }, 6000)

        } else {


            //set autogenerate code to as CODE just for display purpuse
            if (addNew == true && nullCode == false) {
                SetCode(autoCode)
            }

            var NIC = strNIC
            var pattern = new RegExp(mobileNumberRegexp);
            var pattern1 = /[0-9]{12}/;
            var pattern2 = /[0-9]{9}[V|X|v|x]/;
            var pattern3 = new RegExp(emailRegexp);


            if (strCode == "" && nullCode == true) {
                displayAlertMessage('danger', "Please Enter Area Code !")
                return;
            }
            if (strTitle == "") {
                displayAlertMessage('danger', "Please Select Title !")
                return;
            }

            if (strFName == "") {
                displayAlertMessage('danger', "Please Enter First Name !")
                return;
            }
            if (strGroup == "") {
                displayAlertMessage('danger', "Please select Sales Executive Group !")
                return;
            }

            if (strLoca == "") {
                displayAlertMessage('danger', "Please Enter Registered Location !")
                return;
            }

            if (NIC == "") {
                displayAlertMessage('danger', ' NIC number is Empty')
                return
            }
            else if (pattern1.test(NIC) == true && NIC.length == 12) {

            }
            else if (pattern2.test(NIC) == true && NIC.length == 10) {

            }
            else {
                displayAlertMessage('danger', 'Invalid NIC number')
                return
            }

            if (strAddress1 == "") {
                displayAlertMessage('danger', "Please Enter Address !")
                return;
            }
            if (strArea == "") {
                displayAlertMessage('danger', "Please Enter Area !")
                return;
            }
            if (strMobile1 == "") {
                displayAlertMessage('danger', "Please Enter Mobile 1 !")
                return;
            }



            if (strMobile1 !== "") {
                if (!pattern.test(strMobile1)) {
                    displayAlertMessage('danger', "Mobile number 1 is not Valid")
                    return;
                } else if (strMobile1.length !== 10 && strMobile1.length !== 12) {
                    displayAlertMessage('danger', "Mobile number 1 is wrong")
                    return;

                }
            }
            if (strMobile2 !== "") {
                if (!pattern.test(strMobile2)) {
                    displayAlertMessage('danger', "Mobile number 2 is not Valid")
                    return;
                } else if (strMobile2.length != 10) {
                    displayAlertMessage('danger', "Mobile number 2 is wrong")
                    return;

                }
            }
            if (strTelephone1 !== "") {
                if (!pattern.test(strTelephone1)) {
                    displayAlertMessage('danger', "Telephone number 1 is not Valid")
                    return;

                } else if (strTelephone1.length != 10) {
                    displayAlertMessage('danger', "Telephone number 1 is wrong")
                    return;

                }
            }
            if (strTelephone2 !== "") {
                if (!pattern.test(strTelephone2)) {
                    displayAlertMessage('danger', "Telephone number 2 is not Valid")
                    return;
                } else if (strTelephone2.length != 10) {
                    displayAlertMessage('danger', "Telephone number 2 is wrong")
                    return;
                }
            }
            if (strFax !== "") {
                if (!pattern.test(strFax)) {
                    displayAlertMessage('danger', "Fax number is not Valid")
                    return;
                } else if (strFax.length != 10) {
                    displayAlertMessage('danger', "strFax number  is wrong")
                    return;
                }
            }
            if (strEmail != "" & !pattern3.test(strEmail)) {
                displayAlertMessage('danger', "Email is not valid")
                return;
            }

            var lastname = strLname == "" ? "zz" : strLname
            var fulastname = strFullName == "" ? "z" : strFullName
            var mobile2 = strMobile2 == "" ? "1" : strMobile2
            var tele1 = strTelephone1 == "" ? "1" : strTelephone1
            var tele2 = strTelephone2 == "" ? "1" : strTelephone2
            var fax = strFax == "" ? "1" : strFax
            var email = strEmail == "" ? "_" : strEmail
            var linkref = strLinkRefe == "" ? "_" : strLinkRefe
            var adres2 = strAddress2 == "" ? "_" : strAddress2
            var adres3 = strAddress3 == "" ? "_" : strAddress3
            var adres4 = strAddress4 == "" ? "_" : strAddress4
            var gglcode = strGLCode == "" ? "_" : strGLCode
            var desig = strDesignation == "" ? "_" : strDesignation

            var ActiveSw = IsActive ? true : false;
            var imgname = ImgName != "" ? ImgName.slice(22,) : "zz"

            // if(ImgName != ""){
            //     imgname = ImgName.slice(22,)
            // }else{
            //     imgname = "zz"
            // }

            var formdata = new FormData();
            if (picture.imageFile != null) {
                formdata.append("img", picture.imageFile, "[PROXY]")
            }
            formdata.append("strCode", addNew == true && nullCode == false ? autoCode : strCode);
            formdata.append("strTitle", strTitle);
            formdata.append("strFName", strFName);
            formdata.append("strLname", lastname);
            formdata.append("strFullName", fulastname);
            formdata.append("strGroup", strGroup);
            formdata.append("strLinkRefe", linkref);
            formdata.append("strNIC", strNIC);
            formdata.append("strGLCode", gglcode);
            formdata.append("strLoca", strLoca);
            formdata.append("strGender", strGender);
            formdata.append("strDesignation", desig);
            formdata.append("strAddress1", strAddress1);
            formdata.append("strAddress2", adres2);
            formdata.append("strAddress3", adres3);
            formdata.append("strAddress4", adres4);
            formdata.append("strArea", strArea);
            formdata.append("strMobile1", strMobile1);
            formdata.append("strMobile2", mobile2);
            formdata.append("strTelephone1", tele1);
            formdata.append("strTelephone2", tele2);
            formdata.append("strFax", fax);
            formdata.append("strEmail", email);
            formdata.append("IsActive", ActiveSw);
            formdata.append("strMenuCode", menuCode);
            formdata.append("strLoggedLocation", LocationCode);
            formdata.append("strLoggedCompany", LogCompanyCode);
            formdata.append("strReason", Reason);
            formdata.append("strCreateBy", LogUserType);
            formdata.append("blAddNew", addNew);
            formdata.append("strImagePath", imgname);
            formdata.append("strSerial", !localStorage.getItem("Serial") ? "" : localStorage.getItem("Serial"))
            formdata.append("strJoinDate", joinDate == "" ? "1900-01-01" : joinDate)
            formdata.append("strResignDate", resignDate == "" ? "1900-01-01" : resignDate)

            // for (var pair of formdata.entries()) {
            //     console.log(pair[0] + ', ' + pair[1]);
            // }

            var requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow',
                headers: { 'Authorization': `Bearer ${authToken}` },
            };


            //loading alert show
            SetLoadingAlert(true)
            if (addNew == true) {
                SetLoadingAlerttitle("Saving...")
            } else {
                SetLoadingAlerttitle("Updating...")
            }

            await fetch(`${ApiURL}salesassistant`, requestOptions)
                .then(response => {
                    if (response.status == "200") {
                        SetLoadingAlert(false)
                        response.json()
                            .then(responseData => {
                                if (responseData.data == "Record Already Exsist!") {
                                    displayAlertMessage('danger', responseData.data)
                                } else if (responseData.data == "Code Already Exsist!") {
                                    displayAlertMessage('danger', responseData.data)
                                    setCodeButton(false)
                                } else {
                                    ClearItem()
                                    displayAlertMessage('success', responseData.data)
                                }
                            }
                            )
                        setTimeout(() => {
                            setShow(false)
                        }, time)
                    } else if (response.status == "400") {
                        SetLoadingAlert(false)
                        response.json()
                            .then(responseData => {
                                setErrorMsg(responseData.msg)
                            })
                        setDisabled(false)
                        setDisabledCode(false)
                        displayAlertMessage('danger', "Error !")
                    } else {
                        SetLoadingAlert(false)
                        ClearItem();
                    }
                })
        }
    }
    //Edit function
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        setaddNew(false)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //********* NIC Validation */
    const NicValidate = (NIC) => {

        var mon =
        {
            "1": ["01", 31],
            "2": ["02", 29],
            "3": ["03", 31],
            "4": ["04", 30],
            "5": ["05", 31],
            "6": ["06", 30],
            "7": ["07", 31],
            "8": ["08", 31],
            "9": ["09", 30],
            "10": ["10", 31],
            "11": ["11", 30],
            "12": ["12", 31]
        };
        if (NIC.length >= 5) {
            var year = "19" + NIC.substr(0, 2);
            var days = parseInt(NIC.substr(2, 3));
            if (days > 500) {

                Setgender("F")
                days = days - 500;
            }
            else {
                Setgender("M")
            }
            var key;
            for (key in mon) {
                if (days > mon[key][1]) {
                    days = days - mon[key][1];
                }
                else {
                    break;
                }
            }
            if (days < 10) {
                days = "0" + days;
            }

            var date = year + "-" + mon[key][0] + "-" + days
            setGenderstate(!Genderstate)
        }
    }

    //********Delete button function */
    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteSalesExecutiveMasterDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {

            displayAlertMessage("danger", result.data)
        }

    }
    //*********Delete button function end */


    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }
    []

    // print Function
    async function handlePrint(option) {
        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/salesassistant/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${menuCode}/${strCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    function RemoveImage() {
        setPicture(photovalues)
        setImgName("")
        setImgvalue("")
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {

                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                history.push('/dashboard')
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 5) {

                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }

                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }

                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            handleNew,
                                                setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveBtnEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to Print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <DPNavBar
                                        buttons={tabList}
                                        activeStatus={customActiveTab}
                                    />
                                    <TabContent
                                        activeTab={customActiveTab}
                                        className="p-3 text"
                                    >
                                        <TabPane tabId="1">
                                            <SalesExecutiveMasterTab1
                                                executive_SelectRowSearch={executive_SelectRowSearch}

                                                code={strCode}
                                                codeonChange={e => {
                                                    let val1 = Text(
                                                        e.target,
                                                        10,
                                                        true,
                                                        false,
                                                        "upper",
                                                        false
                                                    )
                                                    SetCode(val1)
                                                }}
                                                findCode={e => {
                                                    setCodeFind(e.target.value)
                                                }}
                                                title={strTitle}
                                                titleonChange={val2 => {

                                                    Settitle(val2["value"])
                                                }}
                                                fname={strFName}
                                                fnameonChange={e => {
                                                    let val5 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        false,
                                                        "any",
                                                        true
                                                    )
                                                    Setfname(val5)
                                                }}

                                                fnameonblur={e => {
                                                    let val31 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        false,
                                                        "any",
                                                        true
                                                    )

                                                    if (strFullName === "" || strFullName === strLname + " ") {
                                                        Setfulname(val31 + " " + strLname)
                                                    }
                                                }
                                                }
                                                lname={strLname}
                                                lnameonChange={e => {
                                                    let val4 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        false,
                                                        "any",
                                                        true
                                                    )
                                                    Setlname(val4)
                                                }}

                                                lnameonblur={e => {
                                                    let val30 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        false,
                                                        "any",
                                                        true
                                                    )

                                                    if (strFullName === "" || strFullName === strFName + " ") {
                                                        Setfulname(strFName + " " + val30)
                                                    }
                                                }
                                                }

                                                fulname={strFullName}
                                                fulnameonChange={e => {
                                                    let val2 = Text(
                                                        e.target,
                                                        100,
                                                        true,
                                                        false,
                                                        "any",
                                                        true
                                                    )
                                                    Setfulname(val2)
                                                }}
                                                gcode={strGroup}
                                                gcodeonChange={val6 => {
                                                    Setgcode(val6["value"])
                                                }}
                                                refcode={strLinkRefe}
                                                refcodeonChange={e => {
                                                    let val7 = Text(
                                                        e.target,
                                                        30,
                                                        true,
                                                        true,
                                                        "upper",
                                                        false
                                                    )
                                                    Setrefcode(val7)
                                                }}
                                                idnum={strNIC}
                                                idnumonChange={e => {
                                                    // let val8 = Text(
                                                    //     e.target,
                                                    //     12,
                                                    //     true,
                                                    //     false,
                                                    //     "any",
                                                    //     true
                                                    // )
                                                    // Setidnum(val8)
                                                    var val7 = Text(e.target, 12, true, false, "upper", false)
                                                    var pattern1 = /[0-9]{12}/;
                                                    var pattern2 = /[0-9]{9}[V|X|v|x]/;
                                                    if (pattern1.test(val7) == true && val7.length == 12) {
                                                        var num01 = strNIC.slice(2,)
                                                        var num02 = num01.slice(0, 9)
                                                        var num4 = num02 + "V"
                                                        NicValidate(num4)
                                                    } else if (pattern2.test(val7) == true && val7.length == 10) {
                                                        NicValidate(val7)
                                                    } else {
                                                        setGenderstate(false)
                                                    }
                                                    Setidnum(val7)
                                                }}

                                                GlRef={strGLCode}
                                                GlRefonChange={e => {
                                                    let val9 = Text(
                                                        e.target,
                                                        30,
                                                        true,
                                                        true,
                                                        "upper",
                                                        false
                                                    )
                                                    SetGlRef(val9)
                                                }}

                                                ActiveSw={IsActive}
                                                SwonChange={() => {
                                                    SetActive(!IsActive)
                                                }}

                                                reglocation={strLoca}
                                                reglocationonChange={val11 => {
                                                    Setreglocation(val11["value"])
                                                }}
                                                genderstate={Genderstate}
                                                gender={strGender}
                                                genderonChange={val12 => {

                                                    Setgender(val12["value"])
                                                }}

                                                jobdesig={strDesignation}
                                                jobdesigonChange={val13 => {
                                                    Setjobdesig(val13["value"])

                                                }}
                                                //picture upload
                                                fileimage={Imgvalue}
                                                imagesrc={picture.imageSrc}
                                                ShowPreview={e => {
                                                    if (e.target.files && e.target.files[0]) {
                                                        let imageFile = e.target.files[0];
                                                        const reader = new FileReader();
                                                        setImgvalue(e.target.value)
                                                        reader.onload = x => {
                                                            setPicture({
                                                                imageFile,
                                                                imageSrc: x.target.result,
                                                            })
                                                        }
                                                        reader.readAsDataURL(imageFile)
                                                    }
                                                    else {
                                                        setImgvalue("")
                                                        setPicture({
                                                            imageFile: null,
                                                            imageSrc: NoiMage
                                                        })
                                                    }

                                                    // setPicture(e.target.files[0]);
                                                }}

                                                modelTrigger={tog_xlarge}
                                                modelOpen={modal_xlarge}
                                                show={show}
                                                disabledCode={DisabledCode}
                                                disabled={disabled}
                                                AlertColor={AlertColor}
                                                AlertMsg={AlertMsg}
                                                ErrorMsg={ErrorMsg}
                                                menuName={menuName}
                                                salesDataSearch={async () => {
                                                    tog_xlarge();
                                                }}
                                                DataTables={DataTables}
                                                executive_CodeSearchTrigger={tog_xlarge}
                                                executive_CodeSearchOpen={modal_xlarge}
                                                onButtonClick={e => {
                                                    AutoGenerateCode()
                                                    setCodeButton(true)
                                                }}
                                                btnDisable={codeButton}
                                                SearchDisable={searchdisabled}
                                                showFileUpload={(e) => {
                                                    const file = e.target.files[0];
                                                    readExcel(file);
                                                    setvalueUpload(e.target.value)
                                                }}
                                                valueUpload={valueUpload}
                                                menuCode={menuCode}
                                                autoCode={autoCode}
                                                RemoveImage={RemoveImage}
                                                setJoinDate={(e) => {
                                                    setJoinDate(e.target.value)
                                                }}
                                                joinDate={joinDate}
                                                setResignDate={(e) => {
                                                    setResignDate(e.target.value)
                                                }}
                                                resignDate={resignDate}
                                            />

                                        </TabPane>
                                        <TabPane tabId="2">
                                            <SalesExecutiveMasterTab2

                                                address1={strAddress1}
                                                address1onChange={e => {
                                                    let val14 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        true,
                                                        "any",
                                                        true
                                                    )
                                                    Setaddress1(val14)
                                                }}
                                                address2={strAddress2}
                                                address2onChange={e => {
                                                    let val16 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        true,
                                                        "any",
                                                        true
                                                    )
                                                    Setaddress2(val16)
                                                }}
                                                address3={strAddress3}
                                                address3onChange={e => {
                                                    let val17 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        true,
                                                        "any",
                                                        true
                                                    )
                                                    Setaddress3(val17)
                                                }}
                                                address4={strAddress4}
                                                address4onChange={e => {
                                                    let val18 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        true,
                                                        "any",
                                                        true
                                                    )
                                                    Setaddress4(val18)
                                                }}
                                                AreaValue={strArea}
                                                AreaonChange={val20 => {
                                                    Setarea(val20["value"])
                                                }}
                                                mobi1={strMobile1}
                                                mobi1onChange={e => {
                                                    let val21 = Text(e.target, 12, true, true, "any", false)
                                                    Setmobi1(val21)
                                                }}

                                                mobi2={strMobile2}
                                                mobi2onChange={e => {
                                                    let val22 = Text(e.target, 12, true, true, "any", false)
                                                    Setmobi2(val22)
                                                }}
                                                tele1={strTelephone1}
                                                tele1onChange={e => {
                                                    let val23 = Text(e.target, 12, true, true, "any", false)
                                                    Settele1(val23)
                                                }}
                                                tele2={strTelephone2}
                                                tele2onChange={e => {
                                                    let val24 = Text(e.target, 12, true, true, "any", false)
                                                    Settele2(val24)
                                                }}
                                                fax={strFax}
                                                faxonChange={e => {
                                                    let val25 = Text(e.target, 12, true, true, "any", false)
                                                    Setfax(val25)
                                                }}
                                                email={strEmail}
                                                emailonChange={e => {
                                                    let val26 = Text(
                                                        e.target,
                                                        50,
                                                        true,
                                                        true,
                                                        "any",
                                                        false
                                                    )
                                                    Setemail(val26)
                                                }}
                                                modelTrigger={tog_xlarge}
                                                modelOpen={modal_xlarge}
                                                show={show}
                                                disabledCode={DisabledCode}
                                                disabled={disabled}
                                                AlertColor={AlertColor}
                                                AlertMsg={AlertMsg}
                                                ErrorMsg={ErrorMsg}
                                            />

                                        </TabPane>
                                        {/* <TabPane tabId="3">
                                            <Performance />
                                        </TabPane> */}
                                    </TabContent>
                                    <Row>
                                        {/* infor box */}
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
export default SalesExecutiveMaster